import {COLORWAY_DATA, EXTERIOR_TONE_DATA} from "../../../../../core/constants/color";
import {useSelector} from "react-redux";
import ColorwayAccordion from "../molecules/ColorwayAccordian";
import {useColorway} from "../../../../hooks/controller/useColorway";
import ExteriorToneAccordion from "../molecules/ExteriorToneAccordian";
import {useExteriorTone} from "../../../../hooks/controller/useExteriorTone";
import useMainColors from "../../../../hooks/controller/useMainColors";
import {Scrollbars} from "react-custom-scrollbars-2";

const MIDDLE_LAYER_STEPS = ["INT_KEY", "INT_SECONDARY", "INT_THIRD", "EXT_MAIN", "EXT_SPECIAL"];

const OptionMiddleLayer = ({slideToSubHandler, slideToMainHandler}) => {
  const navData = useSelector(state => state.menuOpen.navData);
  const currentNavigation = useSelector(state => state.optionWindow.currentNavigation);
  const currentStep = useSelector(state => state.optionWindow.currentStep);
  const langData = useSelector(state => state.theme.langData);
  const configData = useSelector(state => state.optionWindow.CONFIG_DATA);
  const currentColorway = configData?.COLORWAY;
  const { handleColorwayToggle } = useColorway();
  const { handleToneToggle } = useExteriorTone();

  const navigationDataObject = navData.processedNavData?.find(
    nav => nav.linkPath?.replaceAll(/[\{\}\[\]\/?.,;:|\)*~`!^\+<>@\#$%&\\\=\(\'\"]/gi, "") === currentNavigation
  );
  const stepObject = navigationDataObject?.navigationSteps?.find(step => step.id === currentStep?.id);
  const { exteriorColors, interiorColors } = useMainColors(stepObject);

  const shouldShowContent = MIDDLE_LAYER_STEPS.includes(currentStep?.code);
  const isExteriorStep = currentStep?.code?.startsWith("EXT_");

  const renderExteriorAccordions = () => {
    if (!exteriorColors) return null;

    return EXTERIOR_TONE_DATA.map(tone => {
      const hasSecondaryColor = !!configData?.EXT_SPECIAL;
      const isExpanded = (tone.toneCode === "SINGLE_TONE" && !hasSecondaryColor) ||
        (tone.toneCode === "DUAL_TONE" && hasSecondaryColor);

      return (
        <ExteriorToneAccordion
          key={tone.toneCode}
          tone={tone}
          isExpanded={isExpanded}
          handleToggle={handleToneToggle}
          primaryColorItem={exteriorColors.primaryColor}
          secondaryColorItem={exteriorColors.secondaryColor}
          stepObject={exteriorColors.stepObject}
          navigationDataObject={navigationDataObject}
          slideToSubHandler={slideToSubHandler}
        />
      )
    });
  };

  const renderInteriorAccordions = () => {
    if (!interiorColors) return null;

    return Object.values(COLORWAY_DATA).map(colorway => {

      return (
        <ColorwayAccordion
          key={colorway.colorwayCode}
          colorway={colorway}
          isExpanded={currentColorway === colorway.colorwayCode}
          handleToggle={handleColorwayToggle}
          keyColorItem={interiorColors.keyColor}
          secondaryColorItem={interiorColors.secondaryColor}
          thirdColorItem={interiorColors.thirdColor}
          stepObject={interiorColors.stepObject}
          navigationDataObject={navigationDataObject}
          slideToSubHandler={slideToSubHandler}
        />
      )
    });
  };

  if (!shouldShowContent) {
    return <div className="option-container" />;
  }

  return (
    <div className="option-container">
      <div className="option-h1" data-expand={true} style={{display: "flex", flexDirection: "column", height: "100%"}}>
        <div className="option-subwrap-header">
          <button type="button" className={"slide-to-main"} onClick={() => slideToMainHandler("1")}>
            back
          </button>
          <h1>{navigationDataObject?.[langData.langName]}</h1>
        </div>
        <div className={"scrollable-area"}>
          <Scrollbars autoHide>
            <div className="option-h2">
              {isExteriorStep ? renderExteriorAccordions() : renderInteriorAccordions()}
            </div>
          </Scrollbars>
        </div>
      </div>
    </div>
  );
}

export default OptionMiddleLayer;
